export default [
    {
        title: 'recursos_humanos.titulo',
        fontIcon: 'university',
        resource: 'Recursos Humanos',
        action: 'ver-rrhh',
        children: [
            {
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Recursos Humanos',
                action: 'ver-rrhh-dashboard',
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Recursos Humanos',
                action: 'ver-rrhh-configuracion',
                children: [
                    {
                        route: 'rrhh-configuracion-permisos-salida',
                        title: 'recursos_humanos.configuracion.permisos_salida.titulo',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-configuracion-permisos-salida',
                    },
                    {
                        route: 'rrhh-configuracion-permisos-fabrica',
                        title: 'recursos_humanos.configuracion.permisos_fabrica.titulo',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-configuracion-permisos-fabrica',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Recursos Humanos',
                action: 'ver-rrhh-mantenimiento',
                children: [
                    // {
                    //     route: "rrhh-mantenimiento-tipos-permisos",
                    //     title: "Tipos permisos",
                    //     resource: "Recursos Humanos",
                    //     action: "ver-rrhh-mantenimiento-tipos-permisos",
                    // },
                    {
                        route: 'rrhh-mantenimiento-examenes-medicos',
                        title: 'Examenes médicos',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-mantenimiento-examenes-medicos',
                    },
                    {
                        route: 'rrhh-mantenimiento-examenes-por-seccion',
                        title: 'Examenes médicos por seccion',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-mantenimiento-examenes-por-seccion',
                    },
                    {
                        route: 'rrhh-mantenimiento-somos-santa-priscila',
                        title: 'recursos_humanos.mantenimiento.somos_santa_priscila',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-mantenimiento-somos-santa-priscila',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Recursos Humanos',
                action: 'ver-rrhh-transacciones',
                children: [
                    {
                        title: 'Datos generales',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-datosGenerales',
                        children: [
                            {
                                route: 'rrhh-preingreso',
                                title: 'Preingreso',
                                resource: 'Recursos Humanos',
                                action: 'ver-rrhh-registro-preingreso',
                            },
                        ],
                    },
                    {
                        route: 'rrhh-transacciones-generador-permisos',
                        title: 'recursos_humanos.transacciones.generador_permisos.titulo',
                        fontIcon: 'person-walking-dashed-line-arrow-right',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-generador-permisos',
                    },
                    {
                        route: 'rrhh-transacciones-atencion-permisos',
                        title: 'recursos_humanos.transacciones.atencion_permisos.titulo',
                        fontIcon: 'clipboard-user',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-atencion-permisos',
                    },
                    {
                        route: 'rrhh-transacciones-permisos-estudio',
                        title: 'Permisos de estudio',
                        fontIcon: 'clipboard-user',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-permisos-estudio',
                    },
                    {
                        route: 'rrhh-transacciones-memorandum',
                        title: 'recursos_humanos.transacciones.memorandum.titulo',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-memorandum',
                    },
                    {
                        route: 'rrhh-transacciones-empresas-complementarios',
                        title: 'recursos_humanos.transacciones.empresa_complementarios.title',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-empresas-complementarios',
                    },
                    {
                        route: 'rrhh-transacciones-empleados-complementarios',
                        title: 'recursos_humanos.transacciones.complementario.title',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-empleados-complementarios',
                    },
                    {
                        route: 'rrhh-transacciones-lista-empleados-complementarios',
                        title: 'recursos_humanos.transacciones.complementario.title_listado',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-lista-empleados-complementarios',
                    },
                    {
                        route: 'rrhh-transacciones-cargas-familiares-complementarios',
                        title: 'recursos_humanos.transacciones.cargas_familiares.title',
                        icon: 'UsersIcon',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-cargas-familiares-complementarios',
                    },
                    {
                        route: 'rrhh-transacciones-planes-claro',
                        title: 'Administración planes claro',
                        icon: 'PhoneCallIcon',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-transacciones-planes-claro',
                    },
                ],
            },
            {
                title: 'Informes',
                resource: 'Recursos Humanos',
                fontIcon: 'file-prescription',
                action: 'ver-rrhh-informes',
                children: [
                    // {
                    //     route: "rrhh-personal-produccion",
                    //     title: "Listado de personal producción",
                    //     fontIcon: "clipboard-list",
                    //     resource: "Recursos Humanos",
                    //     action: "ver-rrhh-informes-personal-produccion",
                    // },
                    {
                        route: 'rrhh-informe-permisos-empleados',
                        title: 'recursos_humanos.informes.permisos_salida.titulo',
                        fontIcon: 'file-circle-check',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informes-permisos-empleados',
                    },
                    {
                        route: 'rrhh-informe-memorandums',
                        title: 'recursos_humanos.informes.memorandum.titulo',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informes-memorandum',
                    },
                    {
                        route: 'rrhh-informe-marcaciones-complementarios',
                        title: 'recursos_humanos.informes.marcacion_complemantario.titulo',
                        fontIcon: 'signature',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informe-marcaciones-complementarios',
                    },
                    {
                        route: 'rrhh-informe-marcaciones-semanal',
                        title: 'recursos_humanos.informes.marcacion_semanal.titulo',
                        fontIcon: 'calendar-week',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informe-marcaciones-semanal',
                    },
                    {
                        route: 'rrhh-informe-correo-institucional',
                        title: 'recursos_humanos.informes.correo_institucional.titulo',
                        icon: 'MailIcon',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informe-correo-institucional',
                    },
                    {
                        route: 'rrhh-informe-encuestas',
                        title: 'recursos_humanos.informes.encuestas.titulo',
                        fontIcon: 'clipboard-list',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informe-encuestas',
                    },
                    {
                        route: 'rrhh-informes-panel-indicador',
                        title: 'Panel de indicadores',
                        fontIcon: 'clipboard-list',
                        resource: 'Recursos Humanos',
                        action: 'ver-rrhh-informes-panel-indicador',
                    },
                ],
            },
        ],
    },
]
